import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from '@src/design-system/dialog';
import { DeleteConfirmDialog } from '@src/design-system/molecules/delete-confirm-dialog-button';
import { Trash } from 'iconsax-react';

import reminderTemplateApi from '../services/reminder-template-api';

interface DeleteReminderTemplateButtonProps {
  id: number;
  name?: string;
}

export const DeleteReminderTemplateButton = ({
  id,
  name,
}: DeleteReminderTemplateButtonProps) => {
  const { mutate: deleteReminderTemplate, isPending } =
    reminderTemplateApi.useDelete();

  return (
    <Dialog>
      <DialogTrigger onClick={(e) => e.stopPropagation()}>
        <div className='size-8 cursor-pointer rounded-lg flex items-center justify-center hover:bg-red-100 hover:text-red-500'>
          <Trash size={18} />
        </div>
      </DialogTrigger>
      <DialogContent
        align='center'
        onClick={(e) => e.stopPropagation()}
      >
        <DeleteConfirmDialog
          title={`Are you sure you want to delete ${name ? `"${name}"` : 'this reminder template'}?`}
          onConfirm={(closeModal) =>
            deleteReminderTemplate(
              { id },
              {
                onSuccess() {
                  closeModal();
                },
              }
            )
          }
          isLoading={isPending}
          confirmText='Yes, delete'
          cancelText='Cancel'
        />
      </DialogContent>
    </Dialog>
  );
};
